module.exports = __webpack_public_path__ + "img/arrow.606d0da4.svg";